// Styles
import styled from 'styled-components'
import cdaExample from 'assets/cda_example.svg'

// Core
import React, {Fragment} from 'react'

// Components, actions, models, etc.
import EventNoteIcon from '@material-ui/icons/EventNote'
import {CheckoutSummaryDivider, CheckoutSummaryItem} from './CheckoutSummaryItems'
import Image from 'components/Image'

// 3rd Party
import moment from 'moment'
import classNames from 'classnames'

const DELIVERY_DATE_LOADING = 'Delivery date to be calculated'
type DeliveryDateProps = {
  dueDate?: string
}

const DeliveryDate = ({dueDate}: DeliveryDateProps) => {
  return (
    <Fragment>
      <DeliveryDate.Styled>
        <div>
          <h4 className='delivery-date-title'>Collateral Desktop Analysis (CDA®)</h4>
          <div className={classNames({'delivery-estimate': true, estimated: dueDate})}>
            <EventNoteIcon />
            <span>
              {dueDate
                ? `Estimated Delivery ${moment(dueDate).format('MMM D, YYYY')}`
                : DELIVERY_DATE_LOADING}
            </span>
          </div>
        </div>
        <div>
          <Image src={cdaExample} width='96px' height='72px' className='cda-template-image' />
        </div>
      </DeliveryDate.Styled>
      <CheckoutSummaryDivider />
    </Fragment>
  )
}

DeliveryDate.Styled = styled(CheckoutSummaryItem)`
  align-items: center;

  .cda-template-image {
    border-radius: 6px;
    background-color: ${({theme}) => theme.colors.stone.lighter};
  }

  .delivery-date-title {
    line-height: 22px;
    margin-bottom: 8px;
  }

  .delivery-estimate {
    display: flex;
    align-items: center;
    column-gap: 6px;
    font-size: 14px;

    &:not(.estimated) {
      color: ${({theme}) => theme.colors.grayscale.gray};
    }

    .portal-MuiSvgIcon-root {
      font-size: 16px;
    }
  }
`

export default DeliveryDate
